<template>
  <header
    :class="readyAction? 'ready-action' : ''"
  >
    <div class="fl">
      <quick-menu />
    </div>
    <div class="fr">
      <out-link />
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import QuickMenu from './QuickMenu'
import OutLink from './OutLink'

export default {
  name: 'Header',
  components: {
    OutLink,
    QuickMenu
  },
  computed: {
    ...mapState('common', {
      readyAction: state => state.readyAction
    })
  },
  mounted () {
  }
}
</script>
